import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/rootReducers";
import { FilterTransactionDetails } from "../models";
import {
  filterTransaction,
  resetFilterTransaction,
} from "../redux/actions/getFilterTransaction";
interface transactionFilterProps {
  token: string;
  merchantId: string;
  userId: string;
}

const useFilterTransactionHook = (
  token: string,
  merchantId: string,
  userId: string,
  outletId: string,
  partnerIds?: string[],
) => {
  const transactionApi = useSelector(
    (state: RootState) => state.transactionsFilterReducer,
  );
  const [filterDetails, setFilterDetails]: any = useState();
  const dispatch = useDispatch();

  const getFilteredTransactionHook = (
    filterDetails: FilterTransactionDetails,
    pageNumber: any,
  ) => {
    setFilterDetails(filterDetails);
    // dispatch(filterTransaction(token, filterDetails, pageNumber, merchantId, outletId, userId));
    dispatch(
      filterTransaction(
        token,
        filterDetails,
        pageNumber,
        merchantId,
        userId,
        outletId,
        partnerIds,
      ),
    );
  };

  const ResetFilterReducer = () => {
    return () => {
      dispatch(resetFilterTransaction());
    };
  };

  const handleRefreshTransactionFilter = () => {
    getFilteredTransactionHook(
      filterDetails,
      transactionApi?.transactionListDetails?.pageable?.pageNumber
        ? transactionApi?.transactionListDetails?.pageable?.pageNumber
        : 0,
    );
  };

  return [
    transactionApi,
    getFilteredTransactionHook,
    ResetFilterReducer,
    handleRefreshTransactionFilter,
  ];
};

export default useFilterTransactionHook;
